import React, { useCallback } from "react";

import { useAppDispatch, useAppSelector } from "../../../Store/Hooks";
import { fetchOrganizationSettings } from "../../../Store/Reducers/VendorAdminSlice";
import {
  getFromLocalStorage,
  STORAGE_KEYS,
} from "../../../Utils/Helper/LocalStorage";
import OrgProductTelemetryPanel from "../../OrgProductTelemetryPanel";

const VendorProductTelemetryContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector(state => state.authentication);
  const loggedInUser = getFromLocalStorage(STORAGE_KEYS.LOGGED_IN_USER);

  const orgId = user?.user?.tenant_id || loggedInUser?.tenantId || null;
  const organizationName =
    loggedInUser?.tenantName ||
    user?.user?.tenant_name ||
    user?.user?.tenant_domain ||
    undefined;

  const handleAccessDenied = useCallback(() => {
    dispatch(fetchOrganizationSettings());
  }, [dispatch]);

  return (
    <OrgProductTelemetryPanel
      orgId={orgId}
      organizationName={organizationName}
      showHeader
      onAccessDenied={handleAccessDenied}
    />
  );
};

export default VendorProductTelemetryContainer;
